var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerantwoordelijkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 42,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0,56.49c0-33.3,51.24-33.3,51.24,0",
    fill: "#bebdbd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m39.54,13.92c0,7.69-6.23,13.92-13.92,13.92s-13.92-6.23-13.92-13.92S17.94,0,25.62,0s13.92,6.23,13.92,13.92Z",
    fill: "#bebdbd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m46.87,28.52c-2.53,2.46-7.06,7.9-7.58,7.38s-2.02-1.87-3.02-2.81",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m46.87,28.44s-7.29,7.28-7.59,7.59-3.01-3.01-3.01-3.01",
    fill: "none",
    stroke: "#009fe3",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerantwoordelijkIcon);
export default __webpack_public_path__ + "static/media/verantwoordelijk-icon.a9be8011.svg";
export { ForwardRef as ReactComponent };